$(document).ready(function(){
    $('.photos').bxSlider({
        slideMargin: 0
    });

    $('.bxslider').bxSlider({
        slideMargin: 0
    });
});
